import { Button } from "arag-ui-lib";
import { PRIMARY, QUATERNARY, RIGHT, BUTTON } from "./constants";
import '../style/button.css';

const GroupButtons = (props) => {
    const {
        primaryLabel,
        onPrimaryClick,
        primaryVariant = PRIMARY,
        primaryTestId,
        // defaults to a plain button; pass SUBMIT explicitly for form-submitting buttons
        primaryType = BUTTON,
        secondaryLabel,
        onSecondaryClick,
        secondaryVariant = QUATERNARY,
        secondaryTestId,
        secondaryType = BUTTON,
        arrowDirection = RIGHT,
    } = props;

    return (
        <div className={"grouped-buttons"}>
            <Button
                buttonTestId={primaryTestId}
                type={primaryType}
                onClick={onPrimaryClick}
                label={primaryLabel}
                variant={primaryVariant}
                arrowDirection={arrowDirection}
            />
            <Button
                buttonTestId={secondaryTestId}
                type={secondaryType}
                onClick={onSecondaryClick}
                label={secondaryLabel}
                variant={secondaryVariant}
                arrowDirection={arrowDirection}
            />
        </div>
    );
};

export default GroupButtons;
